import styled from 'styled-components';
import { mobileWidth } from '~/constants/metrics';

export const AddUserSearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${mobileWidth}) {
    flex-direction: column;
    align-items: flex-end;
  }
`;
